

class Dnb{
    [x: string]: any;
    $onInit(){
        this.updateLength();
        this.uploader.onAfterAddingFile = (item)=>{
            if(item.file.type == 'audio/mp3' || item.file.type == 'audio/wav' || item.file.type == 'audio/ogg' || item.file.type == 'audio/opus'){
                this.updateLength();
                this.typeError = false;
            }else {
                item.remove();
                this.updateLength();
                this.typeError = true;
            }
        };
    }
    getRequired(){
        return this.required ? 1 : 0;
    }
    deleteFile(){
        this.uploader.clearQueue();
        this.updateLength();
    }
    updateLength(){
        this.length = this.uploader.queue.length;
    }

}
export default {
    controller:Dnb,
    template : require('./phone.settings.dnb.html'),
    bindings: {
        uploader: '<',
        required:'<'
    }
};
